export default __webpack_public_path__ + "static/media/feature-tile-icon-06.74b0477e.svg";